/* eslint-disable no-undef */
var cookieBannerClose = document.querySelector('[data-accept-cookies]');
var cookieBanner = document.querySelector('[data-cookie-banner]');

function setupBanner() {
  if (!Cookies.get('genovac-cookies-accepted')) {
    cookieBanner.setAttribute('aria-hidden', false);
  }
}

function closeBanner() {
  cookieBanner.setAttribute('aria-hidden', true);
  Cookies.set('genovac-cookies-accepted', 'true', {
    expires: 1
  });
}

setupBanner();
cookieBannerClose.addEventListener('click', closeBanner, false);